import { getSession } from '../auth';

const KEY = 'clt-selected-batch';

export function getSelectedBatchId(): string {
  const tenant = getSession()?.tenantId || 'techtatwa';
  const stored = localStorage.getItem(KEY);
  // Production: selected batch id is per-tenant; fall back to an empty string.
  return stored || '';
}

export function setSelectedBatchId(id: string) {
  localStorage.setItem(KEY, id);
}
